import request from '../utils/request'

/**
 * 获取所有发音人信息
 */
export function getSpeakerCategoryList () {
  return request({
    url: '/voices/speaker_category_list',
    method: 'post'
  })
}

/**
 * 获取所有发音人信息
 */
export function getSpeakersList (data) {
  return request({
    url: '/voices/speaker_list/v2',
    method: 'post',
    data
  })
}

/**
 * 微信小程序合成
 */
export function miniAPPVoiceSynthsize (data) {
  return request({
    url: '/voices/synthesize_mp',
    method: 'post',
    data
  })
}
